export default __webpack_public_path__ + "static/media/meter.fcd4a415.svg";